import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import pluralize from "lib/pluralize";
import { isInPast } from "lib/dateUtils";
import Badge from "hardcover-ui/components/Badge";
import AboutSeries from "components/series/AboutSeries";
import { BookGroupSizeType, BookSeriesContextType } from "../types";
import BookGroupHeaderWrapper from "./parts/BookGroupHeaderWrapper";

export default function BookSeriesHeader({
  context,
  size,
}: {
  context: BookSeriesContextType;
  size: BookGroupSizeType;
}) {
  const uniqBookSeries = context.series.bookSeries;
  const releasedBooks = uniqBookSeries.filter((bs) => {
    return isInPast(bs.book.releaseDate);
  });
  const releasedBooksCount = releasedBooks.length;
  const primaryWorksCount = releasedBooks.filter(
    (bs) => bs.position && Math.round(bs.position) === bs.position
  ).length;

  return (
    <BookGroupHeaderWrapper size={size}>
      <div className="flex flex-row space-x-2 mb-1">
        <Text variant="secondary" as="p" size="sm" className="font-semibold">
          {context.activeBookSeries.featured && <span>Featured </span>}
          Series
        </Text>
        {primaryWorksCount > 0 ? (
          <>
            <Badge
              size="sm"
              variant={
                context.activeBookSeries.featured ? "accent" : "secondary"
              }
            >
              {primaryWorksCount.toLocaleString()}{" "}
              {pluralize("primary book", primaryWorksCount)}
            </Badge>
            {primaryWorksCount !== releasedBooksCount && (
              <Badge size="sm" variant="secondary">
                {releasedBooksCount.toLocaleString()}{" "}
                {pluralize("released book", releasedBooksCount)}
              </Badge>
            )}
          </>
        ) : (
          <Badge size="sm" variant="secondary">
            {releasedBooksCount.toLocaleString()}{" "}
            {pluralize("released book", releasedBooksCount)}
          </Badge>
        )}
      </div>
      <Heading level={3} size={size === "lg" ? "md" : "sm"} className="mb-2">
        {context.activeBookSeries.details?.length > 0 && (
          <span>#{context.activeBookSeries.details} in </span>
        )}
        <TextLink href={`/series/${context.series.slug}`}>
          {context.series.name}
        </TextLink>
      </Heading>
      <AboutSeries series={context.series} />
    </BookGroupHeaderWrapper>
  );
}
